export const parseRoute = (href: string, basePath: string) => {
  const parsedBasePath = basePath.replace(/\/+$/, "") || "/";
  const validPath = `${parsedBasePath}${href}`.replace("//", "/");
  const route = href === "/" ? parsedBasePath : validPath;
  return route;
};
